<template>
    <div class="index-container" :class="{'sidebar-open': sidebar}">
        <top-section>
            Products
            <template v-slot:buttons>
                 <b-button  
                  tag="router-link"
                    label="non sincronizzati" 
                     :to="{name: 'product.notsync'}"
                    />
                <b-button v-if="checkedRows.length" tag="router-link"
                          type="is-warning"
                          class="is-uppercase"
                          label="Mass Category Management"
                          :to="{name: 'product.mass.category'}"/>
                <b-button v-if="checkedRows.length" tag="router-link"
                          type="is-primary"
                          class="is-uppercase"
                          label="Mass Update"
                          :to="{name: 'product.mass.update'}"/>
            </template>
        </top-section>

        <product-table-section
            :data="products"
            :columns="columns"
            model="product"
            :tableShouldLoad="tableShouldLoad"
            pagination-route="product.index"
            :use-named-route="true"
            searchable checkable :checked-rows.sync="checkedRows"
            @handleProductSearch="handleProductSearch"
        />

        <portal to="sidebar">
            <section class="inner-content product-search">
                <b-tabs type="is-boxed">
                    <b-tab-item :label="__('strings.product.filters')">
                        <product-side-search
                            :brands="filters.brands"
                            :seasons="filters.seasons"
                            :categories="filters.categories"
                            :genders="filters.genders"
                            :retailers="filters.retailers"
                            :stocks="filters.stocks"
                            :filters="inputs"
                            @handleProductSearch="handleProductSearch"/>
                    </b-tab-item>
                    <b-tab-item :label="__('strings.product.search_by_sku')">
                        <product-search-by-sku
                            :filters="inputs"
                            @handleProductSearch="handleProductSearch"
                        ></product-search-by-sku>
                    </b-tab-item>
                </b-tabs>
            </section>
        </portal>
    </div>
</template>

<script>
import ProductTableSection from "./table/ProductTableSection";

export default {
    components: {ProductTableSection},
    data() {
        return {
            checkedRows: [],
            columns: [],
            products: [],
            sidebar: false,
            tableShouldLoad: true,
            filtersLoaded: false,
            filters: {
                brands: {
                    toRetrieve: true,
                    model: 'brand',
                    input: 'brand_id'
                },
                genders: {
                    toRetrieve: true,
                    model: 'gender',
                    input: 'gender_id'
                },
                seasons: {
                    toRetrieve: true,
                    model: 'season',
                    input: 'season_id'
                },
                categories: {
                    toRetrieve: true,
                    model: 'category',
                    input: 'category_id'
                },
                retailers: {
                    data: [
                        {
                            id: 1,
                            name: "SamGP+FL",
                        },
                        {
                            id: 2,
                            name: "SamGG",
                        }]
                },
                stocks: {
                    data: [
                        {
                            id: 0,
                            name: "Out of Stock",
                        },
                        {
                            id: 1,
                            name: "In Stock",
                        }]
                },
            },
            inputs: {
                retailers: [],
                in_stock: [],
                brand_id: [],
                gender_id: [],
                category_id: [],
                parent_category_id: undefined,
                sub_category_id: undefined,
                season_id: [],
                sku: [],
                //page: undefined,
            },
            filteredProductIds: null,
            onHistoryPopstateCb: this.onHistoryPopstate.bind(this)
        }
    },
    beforeMount() {
        for (let [filterKey, filterProp] of Object.entries(this.filters)) {
            if (filterProp.toRetrieve) {
                this.filters[filterKey] = {
                    ...filterProp,
                    data: [],
                    loading: true,
                    error: null,
                    input: ''
                };
                this.fetchFilters(filterKey, filterProp);
            }
        }
        this.filtersLoaded = true;
        let searchParams = new URLSearchParams(window.location.search);
        let query = {};
        for (let [key, value] of searchParams.entries()) {
            query[key] = searchParams.get(key).split(",").map((el) => eval(el));
        }
        this.assignData(query);
        // Set the current page from query string
        this.inputs.page = searchParams.get("page") ? eval(searchParams.get("page")) : 1;
    },
    created() {
        axios.get('/columns/product').then(response => {
            this.columns = response.data
        });
    },
    mounted() {
        this.handleProductSearch();
    },
    methods: {
        /**
         * This method is used to retrieve programmatically the data for filters
         */
        fetchFilters(filterKey, filterProp) {
            this.filters[filterKey].loading = true;

            // Set the endpoint to fetch
            let endpoint = filterProp.model;
            endpoint += (filterProp.hasOwnProperty('filters') || this.filteredProductIds) ? '/filter' : '/index';

            // Fetch the filter
            axios.get(endpoint)
                .then(response => {
                    this.filters[filterKey].data = response.data;
                })
                .catch(error => {
                    this.filters[filterKey].error = error.response.data.message;
                })
                .finally(() => {
                    this.filters[filterKey].loading = false
                })
        },
        selectOptions(option, field) {
            this.inputs[field] = option ? option.id : null;
            this.filterProducts();
        },
        /**
         * This method is used to retrieve filtered data
         */
        handleProductSearch(filters) {
            this.inputs = {...this.inputs, ...filters};

            let searchParams = new URLSearchParams(window.location.search);
            let query = {};
            let queryString = {};
            for (let [key, value] of Object.entries(this.inputs)) {
                if (value === undefined || value.length === 0) continue;
                query[key] = value;
                searchParams.set(key, value);
                queryString[key] = Array.isArray(value) ? value.join(",") : value;
            }

            //this.$router.replace({ query: queryString });

            // Replace the old query string
            this.tableShouldLoad = true;
            axios.get('/product/filter', {params: searchParams})
                .then(response => {
                    this.products = response.data.products;
                    this.filteredProductIds = response.data.product_ids;
                })
                .finally(() => {
                    this.tableShouldLoad = false;
                    window.scrollTo({top: 0, behavior: 'smooth'})
                });
        },
        assignData(data) {
            for (let key of Object.keys(this.inputs)) {
                if (data.hasOwnProperty(key)) {
                    this.inputs[key] = data[key];
                }
            }
        },
        onHistoryPopstate(event) {
            if (event.state) {
                this.assignData(event.state);
            }
        },
    },
    watch: {
        checkedRows: {
            deep: true,
            handler() {
                this.$emit('update:checkedRows', this.checkedRows)
            }
        }
    }
}
</script>
